import { makeStyles, mergeClasses, tokens, Text } from '@fluentui/react-components';
import * as React from 'react';

const useStyles = makeStyles({
  empty: {
    paddingInline: tokens.spacingHorizontalXXL,
    textAlign: 'center',
    alignContent: 'center',
    color: tokens.colorNeutralForegroundDisabled,
  },
});

interface EmptyProps {
  text: string;
  style?: React.CSSProperties;
}

export const Empty = ({ text, style }: EmptyProps) => {
  const styles = useStyles();

  return (
    <div
      className={mergeClasses(styles.empty)}
      style={style}
    >
      <Text>{text}</Text>
    </div>
  );
};
